import React from 'react';

import { PaymentOptions } from '../components/PaymentOptions';

export function Policies(){
  return (
    <div style={{ textAlign: 'left' }}>
      <h1>Guarantee</h1>
      <p>
        I will always do my absolute best to accommodate your desired date and time. 
        It is important that your session be scheduled at a time that is low stress and 
        fits your needs the most. If your desired date and time are unavailable, 
        I will discuss the next best option for your needs with you and get you moving again.
      </p>
      <h1>Cancellation Policy</h1>
      <ul>
        <li>Cancellations must be requested at least 24 hours in advance</li>
        <li>You will be charged $25.00 for each hour scheduled if you cancel with less than 24 hours notice</li>
      </ul>
      <h1>Payment Options</h1>
      <PaymentOptions />
      <p>
        I use a HIPPA compliant and regulated software and billing platform. 
        It is safe, secure and does not allow anyone access to your credit card numbers, 
        not even me. I only have access to the last 4 digits and the expiration date. 
      </p>
      <h1>Disclaimer</h1>
      <p>
       This is a Therapeutic and Professional service.
      </p>
      <p> 
       There will be NO SEXUAL or INAPPROPRIATE behavior allowed at ANY TIME.
      </p>
      <p> 
       In this case, the therapist will remove themselves from the home or office, 
       the balance will be charged, and authorities will be notified if necessary.
      </p>
      <p> 
       Thank you for your understanding and cooperation. 
      </p>
    </div>
  );
}
